export enum CardProvider {
  Visa = 'visa',
  Mastercard = 'mastercard',
  AmericanExpress = 'american_express',
  CartesBancaires = 'cartes_bancaires',
}
